import { render, staticRenderFns } from "./create-trigger.vue?vue&type=template&id=29b06f38&scoped=true"
import script from "./create-trigger.vue?vue&type=script&lang=js"
export * from "./create-trigger.vue?vue&type=script&lang=js"
import style0 from "./create-trigger.vue?vue&type=style&index=0&id=29b06f38&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b06f38",
  null
  
)

export default component.exports